import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { date } from 'yup/lib/locale';
import Select from 'react-select'
import * as AiIcons from 'react-icons/ai';
import { useQueryClient } from 'react-query'
import * as Yup from "yup";
import { APIURL } from "../../hoc/AxiosSetting/axios.js";
import axios from "axios";

function CertificationStatus() {
    const history = useHistory();
    const { id } = useParams()
    const queryClient = useQueryClient();
    const[show,setShow]= useState(false);

    const [initialValues, setInitialValues] = useState({
        orgCode: 0,
        id:0,
        certifId:0,
        userid:0,
        orgName                 :"",
        scope                   : "" ,
        address                 : "" ,
        certificateno           : "",
        standard                : "",
        typeOfCertification     : "",
        initialcertdate         : new Date(),
        dateofissue             : new Date(),
        expirydate              : new Date(),
        status                  : "",
        certstatusvalue         :"",
        fromSystem              : false, 
        createdBy               : localStorage.getItem("userCode")

    })
    const certstatusOptions = [
        { key: 'Select', value: '-' },
        { key: 'Certification', value: 'Certification' },
        { key: 'Surveillance1', value: 'Surveillance1' },
        { key: 'Surveillance2', value: 'Surveillance2' },
        { key: 'Recertification', value: 'Recertification' }
    ]
    const statusOptions = [
        { key: 'Select', value: '-' },
        { key: 'Active', value: 'Active' },
        { key: 'Inactive', value: 'Inactive' },

   ]
    const mutation = useMutation((params) => Fetcher('patch', '/api/certificatedetails/patch/updatecertificatedetails', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                console.log("line no 60 patch",data.data.response)
                // var tempDatapatch = data.data.response;
                // var tempDatapatch1 = tempDatapatch._id || tempDatapatch.certifId;
               // console.log("line no 61 patch",certifId)
                ToastInstance('Success', 'Certficate status Data Added')
                // console.log("line no 60 patch",tempDatapatch.certifId)
                //history.push("/"+localStorage.getItem("role")+'/viewcertificationstatus/' + data.data.response._id || data.data.response.certifId);

            } else {
                var msg = 'Status - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Status' + error)
        }
    })
    const getUrl = () =>{
        const api= APIURL + '/api/certificatedetails/get/certificatedetailsview/' + id
        axios.get(api)
        .then(certData=>{
                var tempData = certData.data.response;
                tempData.certifId = certData.data.response._id;
                tempData.dateofissue = Date.parse(tempData.dateofissue);
                tempData.initialcertdate = Date.parse(tempData.initialcertdate);
                tempData.expirydate = Date.parse(tempData.expirydate);
                console.log("certData 79",tempData)
                setInitialValues(tempData)

                    if (!tempData.orgCode) {
                        setShow(true)
                    } else {
                        setShow(false)
                    }
        })
        .catch(err=>{
                console.log(err)  
        })
    }
    const { data: OrgList, isLoading: orgLoading } = useQuery(
        'listorg',
        (userid) => Fetcher('get', '/api/certificatedetails/get/listcertificatedetailsdropdownuserwise/'+ localStorage.getItem("userCode") + "/" + localStorage.getItem("role"), {}))
    const { data: CertList, isLoading: certLoading } = useQuery(
            'listCert',
            () => Fetcher('get', '/api/typeofcertifications/get/typeofcertkeyvalue', {}))
    
    const mutationgetCompanyDetails = useMutation((data) => {
        console.log("data certifid",data.certifId, data._id)
        let tempData = {
            orgCode                 : data.orgCode,
            certifId                : data.certifId === "-" ? 0 : data._id,
            orgName                 : data.orgName,
            scope                   : data.scope,
            address                 : data.address,
            certificateno           : data.certificateno,
            standard                : data.standard, 
            typeOfCertification     : data.typeOfCertification,
            initialcertdate         : Date.parse(data.initialcertdate),
            dateofissue             : Date.parse(data.dateofissue),
            expirydate              : Date.parse(data.expirydate),
            status                  : data.status,
            certstatusvalue         : data.certstatusvalue,
            label                   : data.orgName + " - " + data.typeOfCertification,
            createdBy               : localStorage.getItem("userCode")
        }
        console.log("tempdata 125",tempData)
            
            setInitialValues(tempData)
         if(!data.orgCode){
                setShow(true)
         }else{
            setShow(false)
         }
        
    })
    
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        resetForm({ 
            id                      : "", 
            orgName                 : "",
            certifId                : "",
            scope                   : "" ,
            address                 : "" ,
            certificateno           : "",
            standard                : "",
            typeOfCertification     : "",
            initialcertdate         : "",
            dateofissue             : "",
            expirydate              : "",
            status                  : "",
            certstatusvalue         : ""
        })
            console.log("values 146",values)
            mutation.mutate(values)
        }

    useEffect(() => {
            if(id!== undefined){
              getUrl()
                // setShow(true)
            }
           
        },[id!== undefined])

       
    if (orgLoading || certLoading) return <h1>Loading</h1>
    return (
     
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {
                
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                        <div className="formOuterDiv">
                                                        <div className="form1RowDiv" style={{ display: show === false ? 'block' : 'none'}}>
                                                            
                                                                    <FormikControl control='selectNACECode' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e); }} type="text" label='Client Name' />

                                                           
                                                        </div>
                                                        <div className="form1RowDiv" style={{ display: show === true ? 'block' : 'none'}}>
                                                            
                                                            <FormikControl control='input' type="text" label='Organization Name' name='orgName' />
                                                               
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl className="form-control" control='textarea' label="Scope" name='scope' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl className="form-control" control='textarea' label="Company Address" name='address' />
                                                        </div>
                                                        <div className="form2RowDiv">

                                                            <FormikControl className="form-control" control='textarea' label="Certificate No" name='certificateno' />
                                                            <FormikControl control='select' label='Type of Certification *' options={CertList.data.response} name='typeOfCertification' />

                                                            {/* <FormikControl className="form-control" control='textarea' label="Management System Standard" name='standard' /> */}
                                                        </div>
                                                        <div className="form2RowDiv">

                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Original Registered Date' name='dateofissue' />
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Current Issue Date' name='initialcertdate' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Expiry Date' name='expirydate' />
                                                    
                                                        <FormikControl className="form-control" control='select' label="Certfication Status" name='status' options={statusOptions}/>
                                                            

                                                        </div>
                                                        <div className='form2RowDiv'>
                                                        <FormikControl control='select' options={certstatusOptions} name='certstatusvalue' label="Audit Type" />
                                                        </div>
                                                    </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                  

                    <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button className="btn btn-primary float-right" type="submit" >Submit</button>
                                </div>
                                
                            </div>
                            </div>
                </Form>
            }
        </Formik>
    )
}
export default CertificationStatus